import React from 'react';
import { TrendingUp, Scale, MapPin } from 'lucide-react';
import './Stats.css';

const stats = [
  {
    icon: TrendingUp,
    number: "300+",
    label: "Campagnes équipées",
    description: "Municipales, départementales, régionales"
  },
  {
    icon: Scale,
    number: "Remboursable",
    label: "Comptes de campagne",
    description: "Décision Conseil d'État n°499193"
  },
  {
    icon: MapPin,
    number: "Exclusivité",
    label: "Territoriale",
    description: "Un seul client par circonscription"
  }
];

function Stats() {
  return (
    <section id="stats" className="stats">
      <div className="stats__background">
        <div className="stats__gradient" />
      </div>
      
      <div className="stats__container container">
        <div className="stats__header">
          <span className="stats__label">Nos références</span>
          <h2 className="stats__title">
            Ils nous font confiance depuis 2020
          </h2>
          <p className="stats__subtitle">
            Plus de 300 campagnes municipales, départementales et régionales ont utilisé ProcuMatcher.
          </p>
        </div>
        
        <div className="stats__grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-card__icon">
                <stat.icon size={24} />
              </div>
              <div className="stat-card__content">
                <div className="stat-card__number">{stat.number}</div>
                <div className="stat-card__label">{stat.label}</div>
                <div className="stat-card__description">{stat.description}</div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="stats__testimonial">
          <blockquote className="testimonial">
            <p className="testimonial__text">
              "ProcuMatcher nous a permis de gérer plus de 200 procurations en une semaine. 
              L'outil est simple, efficace, et le CERFA pré-rempli fait gagner un temps précieux."
            </p>
            <footer className="testimonial__footer">
              <div className="testimonial__author">
                <strong>Directeur de campagne</strong>
                <span>Élections municipales 2020</span>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}

export default Stats;

